import React from 'react';
import * as Styled from './styled';

export interface OfferDetailsProps {
  locator: string;
  value: string;
  description: string;
  withBackDivider: boolean;
}

export const OfferDetails: React.FC<OfferDetailsProps> = (props) => {

  return (
    <>
      <Styled.Root data-auto={props.locator}>
        <Styled.ValueText isBold>{props.value}</Styled.ValueText>
        <Styled.ValueText isBold={false}>{props.description}</Styled.ValueText>
      </Styled.Root>
      {props.withBackDivider && <Styled.BackDivider />}
    </>
  );
};
